const types = {
  AUTH_CHECK: "AUTH_CHECK",

  DO_LOGIN: "DO_LOGIN",
  DO_LOGIN_SUCCESS: "DO_LOGIN_SUCCESS",
  DO_LOGIN_FAILED: "DO_LOGIN_FAILED",

  DO_LOGOUT: "DO_LOGOUT",
  DO_LOGOUT_SUCCESS: "DO_LOGOUT_SUCCESS",
  DO_LOGOUT_FAILED: "DO_LOGOUT_FAILED",

  DO_REGIST_MEMBER: "DO_REGIST_MEMBER",
  DO_PROFILE_UPDATE: "DO_PROFILE_UPDATE",
  DO_GET_PROFILE: "DO_GET_PROFILE",
  DO_OAUTH_HAPPYS: "DO_OAUTH_HAPPYS",
};
export default types;
